<template>
    <div class="p-4 w-full h-full overflow-hidden relative">
        <WFScrollableArea class="">
            <div class="grid grid-cols-4 gap-x-24 gap-y-12 p-36">
                <div @click="clicked(offer)" v-for="offer in offers" v-bind:key="offer.id" class="card card-border border-2 th-border p-16 bg-white">
                    <div class="card-body flex flex-col gap-32 justify-between h-full">
                        <div>
                            <div class="flex justify-between mb-12">
                                <img v-if="offer.partner" loading="lazy" :src="offer.partner.logo_full_path" class="h-44 max-w-176 object-contain">
                                <div class="discount">{{ offer.discount }}</div>
                            </div>
                            <h2 class="card-title text-20">{{ offer.name }}</h2>
                            <label class="mt-6 text-16 text-neutral">{{ offer.valid }}</label>
                        </div>
                        <div class="card-actions w-full flex justify-between items-end">
                            <div class="font-bold text-18">
                                <WFTranslate k="floor" :params="[offer.floor]"></WFTranslate>
                            </div>
                            <div v-if="offer">
                                <div>
                                    <PakkumiseQR :offer="offer"></PakkumiseQR>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </WFScrollableArea>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { WFScrollableArea } from '@3dwayfinder/wayfinder-vue-components'
import PakkumiseQR from "./PakkumiseQR.vue";

export default {
    components: {
		WFScrollableArea,
        PakkumiseQR
    },
    computed: {
		...mapState(['offers', 'goback']),
	},
    data() {
        return {
        }
    },
    methods: {
        valid (offer) {
            if(offer) {
                return;
            }
            return ""; 
        },
        offerFloor (offer) {
            return [offer.floor];
        },
        clicked (offer) {
            this.$store.dispatch("setPOI", offer.poi);
            this.$store.dispatch("setOffer", offer);
        }
    }
}
</script>

<style>

</style>